import { Helmet } from 'react-helmet';
import whitepapers from '../data/whitepapers';

const Whitepapers = ({ onNavigate }) => {
  const handleNavigate = (path) => {
    if (onNavigate) {
      onNavigate(path);
      return;
    }
    window.location.assign(path);
  };

  return (
    <div className="whitepaper-surface">
      <Helmet>
        <title>Whitepapers | r4j3sh</title>
        <meta
          name="description"
          content="Strategic security whitepapers on APIs, threat landscapes, and resilient defensive postures."
        />
      </Helmet>
      <div className="whitepaper-grid">
        <section className="pt-28 pb-12">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] items-center">
              <div className="space-y-6">
                <p className="whitepaper-eyebrow text-slate-500">Whitepapers</p>
                <h1 className="whitepaper-display text-4xl sm:text-5xl lg:text-6xl leading-tight">
                  Security research built for operators, builders, and leaders.
                </h1>
                <p className="text-lg text-slate-600 max-w-2xl">
                  Deep-dive analysis grounded in the real attack surface. Each paper blends strategy,
                  technical depth, and actionable guidance for teams protecting modern systems.
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    className="whitepaper-button px-6 py-3 rounded-full text-sm font-semibold"
                    onClick={() => handleNavigate(`/whitepapers/${whitepapers[0].slug}`)}
                  >
                    Read the latest paper
                  </button>
                  <button
                    className="whitepaper-button-secondary px-6 py-3 rounded-full text-sm font-semibold"
                    onClick={() => handleNavigate('/#contact')}
                  >
                    Request a briefing
                  </button>
                </div>
              </div>
              <div className="whitepaper-card rounded-3xl p-6 space-y-4 wp-fade-up">
                <p className="text-sm text-slate-500 uppercase tracking-[0.2em]">What you get</p>
                <div className="grid gap-4 sm:grid-cols-2">
                  <div className="rounded-2xl border border-slate-200/70 bg-white/80 p-4">
                    <p className="text-sm font-semibold text-slate-800">Threat intelligence</p>
                    <p className="text-sm text-slate-600 mt-2">
                      Curated insights on the most exploited API failure points.
                    </p>
                  </div>
                  <div className="rounded-2xl border border-slate-200/70 bg-white/80 p-4">
                    <p className="text-sm font-semibold text-slate-800">Actionable defense</p>
                    <p className="text-sm text-slate-600 mt-2">
                      Tactical guidance for hardening, monitoring, and response.
                    </p>
                  </div>
                  <div className="rounded-2xl border border-slate-200/70 bg-white/80 p-4">
                    <p className="text-sm font-semibold text-slate-800">Executive clarity</p>
                    <p className="text-sm text-slate-600 mt-2">
                      Clear framing that aligns technical risk with business impact.
                    </p>
                  </div>
                  <div className="rounded-2xl border border-slate-200/70 bg-white/80 p-4">
                    <p className="text-sm font-semibold text-slate-800">Practical frameworks</p>
                    <p className="text-sm text-slate-600 mt-2">
                      Repeatable playbooks for resilient API security programs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl sm:text-3xl font-semibold">Latest whitepapers</h2>
              <p className="text-sm text-slate-500">{whitepapers.length} release</p>
            </div>
            <div className="grid gap-8 lg:grid-cols-2">
              {whitepapers.map((paper, index) => (
                <article
                  key={paper.id}
                  className="whitepaper-card rounded-3xl overflow-hidden wp-fade-up"
                  style={{ animationDelay: `${index * 120}ms` }}
                >
                  <div className="relative bg-white/90">
                    <img
                      src={paper.coverImage}
                      alt={paper.title}
                      className="w-full h-64 sm:h-72 lg:h-80 object-contain"
                    />
                  </div>
                  <div className="p-6 space-y-4">
                    <div className="flex flex-wrap items-center gap-3 text-sm">
                      <span className="whitepaper-pill px-3 py-1 rounded-full">{paper.category}</span>
                      <span className="text-slate-500">{paper.dateLabel}</span>
                      <span className="text-slate-500">{paper.readingTime}</span>
                    </div>
                    <h3 className="text-2xl font-semibold leading-snug">{paper.title}</h3>
                    <p className="text-slate-600">{paper.summary}</p>
                    <div className="flex flex-wrap gap-3">
                      <button
                        className="whitepaper-button px-5 py-2.5 rounded-full text-sm font-semibold"
                        onClick={() => handleNavigate(`/whitepapers/${paper.slug}`)}
                      >
                        Read whitepaper
                      </button>
                    </div>
                    <p className="text-xs text-slate-500">Author: {paper.author}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Whitepapers;
